import { Box, CircularProgress } from '@mui/material';
import React from 'react';
import CheckOutlinedIcon from '@mui/icons-material/CheckOutlined';
import SpeakerNotesOutlinedIcon from '@mui/icons-material/SpeakerNotesOutlined';
import PropTypes from 'prop-types';
import APIDocuments from '../apiDocuments';
import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
    root: {
        '--primaryColor': theme.palette.primary.main,
        '--selectable-bg': 'alpha(var(--primaryColor), 0.8)',
        '--shadow-color': 'alpha(#000000, 0.15)',
        '--grey': theme.palette.documentViewer.thumbnailGray,
    },

    selectableBlock: {
        position: 'relative',
    },

    selectable: {
        position: 'absolute',
        top: 'calc(50% - 10px)',
        background: 'var(--selectable-bg)',
        borderRadius: '50%',
        width: '32px',
        height: '32px',
        lineHeight: '32px',
        paddingTop: '3px',
        left: 'calc(50% - 16px)',
    },

    bookmarkRibbon: {
        width: '0',
        height: '24px',
        borderRight: '9px solid var(--grey)',
        borderLeft: '9px solid var(--grey)',
        borderBottom: '5px solid transparent',
        position: 'absolute',
        right: '15px',
        top: '0px',
    },

    imageItem: {
        marginLeft: 'auto',
        marginRight: 'auto',
    },

    thumbnailBlock: {
        alignContent: 'center',
        textAlign: 'center',
        position: 'relative',
    },

    thumbnailBlockAsPage: {
        borderStyle: 'solid',
        borderWidth: '0.5px',
        borderColor: theme.palette.documentViewer.thumbnailBorderColor,
        borderRadius: '6px',
        boxShadow: '0px 2px 4px 1px var(--shadow-color)',
    },

    fileIcon: {
        background: theme.palette.documentViewer.thumbnailBlockBackgroundColor,
        border: '0.375px solid transparent',
        borderColor: theme.palette.documentViewer.thumbnailBlockBorderColor,
        borderRadius: '50%',
        padding: '4px 4px 0px 5px',
        color: 'var(--grey)',
        cursor: 'default',
        marginBottom: '-2px',
    },
}));

function ThumbnailPage(props) {
    const classesThumbPage = useStyles();
    const { page = 1 } = props;
    const [width, setWidth] = React.useState(props.width ? props.width : 80);
    const [height, setHeight] = React.useState(props.height ? props.height : 104);
    const [loading, setLoading] = React.useState(true);
    const [image, setImage] = React.useState(null);
    const [mahMaw, setMahMaw] = React.useState([height, width]);
    const [hasBookmark] = React.useState(props.bookmark);
    const [hasAnnotations] = React.useState(props.notes);

    React.useEffect(() => {
        const controller = new AbortController();
        const reader = new FileReader();
        let working = true;
        if (props.docId != null) {
            APIDocuments.getDocPageThumbnail(props.docId, page, controller.signal).then(
                (image) => {
                    if (working)
                        reader.onloadend = () => {
                            const i = new Image();
                            if (reader.result != null && typeof reader.result == 'string') {
                                i.src = reader.result;
                                // i.onload = () => {
                                //     if (i.naturalHeight < i.naturalWidth) {
                                //         const h = height;
                                //         setHeight(width);
                                //         setWidth(h);
                                //         setMahMaw([width, h]);
                                //     }
                                // };
                            }

                            setImage(reader.result);
                            setLoading(false);
                        };
                    if (working) reader.readAsDataURL(image);
                },
                (error) => {
                    //console.debug('getPageThumbImage', error);
                    setImage('/image/assets/error.png');
                    setLoading(false);
                    setMahMaw([height * 0.5, width * 0.5]);
                },
            );
        } else {
            setLoading(true);
        }
        return () => {
            controller.abort();
            if (reader !== null) {
                reader.abort();
            }
            working = false;
            setImage(null);
            setLoading(true);
            setMahMaw([height, width]);
        };
    }, [props.docId]);

    React.useEffect(() => {
        const newWidth = props.width ? props.width : 80;
        const newHeight = props.height ? props.height : 104;
        setWidth(newWidth);
        setHeight(newHeight);
        setMahMaw([newHeight, newWidth]);
    }, [props.width, props.height]);

    return (
        <Box
            style={{ width: width, height: height }}
            className={`${classesThumbPage.thumbnailBlock} ${props.noStyles ? '' : classesThumbPage.thumbnailBlockAsPage} ${props.selectable ? classesThumbPage.selectableBlock : ''}`}
            onClick={() => {
                if (props.selectable && props.onSelected != null) {
                    props.onSelected(page);
                }
            }}
        >
            {loading && <CircularProgress size={30}></CircularProgress>}
            {!loading && image != null && (
                <Box
                    component={'img'}
                    key={'image-page-thumbnail-' + props.docId + '-' + props.page}
                    className={classesThumbPage.imageItem}
                    src={image}
                    style={{ maxWidth: mahMaw[1], maxHeight: mahMaw[0], objectFit: 'contain' }}
                />
            )}
            {hasBookmark && <Box className={classesThumbPage.bookmarkRibbon}></Box>}
            {hasAnnotations && (
                <Box className={classesThumbPage.fileIcon}>
                    <SpeakerNotesOutlinedIcon size={18} />
                </Box>
            )}
            {props.selectable && (
                <Box className={classesThumbPage.selectable}>{props.selected && <CheckOutlinedIcon size={26} color="white" />}</Box>
            )}
        </Box>
    );
}

ThumbnailPage.defaultProps = {
    page: 1,
    width: 112,
    height: 131,
    noStyles: false,
};

ThumbnailPage.propTypes = {
    page: PropTypes.number,
    selectable: PropTypes.bool,
    onSelected: PropTypes.func,
    selected: PropTypes.bool,
    docId: PropTypes.string.isRequired,
    fileName: PropTypes.string,
    width: PropTypes.number,
    height: PropTypes.number,
    contentTypeIco: PropTypes.element,
    notes: PropTypes.bool,
    bookmark: PropTypes.bool,
    isIncorrect: PropTypes.bool,
    onClick: PropTypes.func,
    noStyles: PropTypes.bool,
};

export default ThumbnailPage;
